export const SET_CALCULATION_DATA = "presentation/SET_CALCULATION_DATA";
